<ion-content class="main-admin">
    <app-header [isParentPage]="true" [title]="'Main Admin'"></app-header>
    <div class="main-container">
        <div class="cost-center" (click)="navigateCost()">Cost Center Admin</div>
        <div class="wo-approve" (click)="navigateWO()">WO Approval Admin</div>
    </div>
</ion-content>
